module.exports = __webpack_public_path__ + "img/Nuvio_Black.4a9a01f7.png";